import { Injectable } from '@angular/core';
import {HttpService} from '../http.service';
import {IDefaultResponseT} from '../../models/default-response/response';
import {SEASONS_ROUTE_NEW} from '@api/http/http-routes';
import {ISeasonTablesResponse} from '@api/models/season/season-tables-response';

type SeasonTablesResponse = IDefaultResponseT<ISeasonTablesResponse>;

@Injectable({
  providedIn: 'root'
})
export class SeasonHttpService {

  constructor( private http: HttpService ) { }

  public async getSeasonTables(seasonId: string): Promise<ISeasonTablesResponse | null> {
    const response = await this.http.get<SeasonTablesResponse>([SEASONS_ROUTE_NEW, seasonId, 'tables']);
    if (response.success) {
      return response.data;
    }
    return null;
  }
}
